import client from '../base-api';
import {IAddressBook, IAddressBookFilters, IAddressBookList} from "@/interfaces/AddressBook/IAddressBook";

const serviceURL = '/address-book/client';

const addressBookClientService = {

    getClients(filterData: IAddressBookFilters): Promise<{data: IAddressBookList}> {
        return client.get(`${serviceURL}`, {params: filterData});
    },
    getClient(clientId: number) {
        return client.get(`${serviceURL}/${clientId}`);
    },
    postClient(clientData: IAddressBook) {
        return client.post(`${serviceURL}`, clientData);
    },
    putClient(clientData: IAddressBook, clientId: number) {
        return client.put(`${serviceURL}/${clientId}`, clientData);
    },
    deleteClient(clientId: number) {
        return client.delete(`${serviceURL}/delete/${clientId}`);
    },

};

export default addressBookClientService;
  